import { PrsForPrsList } from 'src/components/shien/pages/PrsListPage/types';
import { PrsActionType } from 'src/types/common/PrsActionType';

export type PrsOrderKind = 'status' | 'name';

export type PrsOrder = {
  [key in PrsOrderKind]: {
    label: '安否順' | '名前順';
    sort: (list: PrsForPrsList[]) => PrsForPrsList[];
  };
};

const prsActionTypeOrder: Array<PrsActionType | undefined> = [undefined, 'visit', 'evacuate'];

export const prsOrders: PrsOrder = {
  status: {
    label: '安否順',
    sort: (persons) => {
      return [...persons].sort((a, b) => {
        // 第１ソートキー：安否ステータス
        const statusComparison = a.sortOrder - b.sortOrder;
        if (statusComparison !== 0) return statusComparison;
        
        // 第２ソートキー：なし or 訪問中 or 避難中
        const actionTypeComparison =
          prsActionTypeOrder.indexOf(a.prsActionType) -
          prsActionTypeOrder.indexOf(b.prsActionType);
        if (actionTypeComparison !== 0) return actionTypeComparison;

        // 第３ソートキー：住所
        const addressComparison = a.address.localeCompare(b.address, 'ja', { numeric: true });
        if (addressComparison !== 0) return addressComparison;

        // 第４ソートキー：要支援者ID
        return comparePrsId(a.prsId, b.prsId);
      });
    },
  },
  name: {
    label: '名前順',
    sort: (persons) => {
      return [...persons].sort((a, b) => {
        // 第１ソートキー：名前フリガナ
        const nameComparison = a.kPrsName.localeCompare(b.kPrsName, 'ja');
        if (nameComparison !== 0) return nameComparison;

        // 第２ソートキー：住所
        const addressComparison = a.address.localeCompare(b.address, 'ja', { numeric: true });
        if (addressComparison !== 0) return addressComparison;

        // 第３ソートキー：要支援者ID
        return comparePrsId(a.prsId, b.prsId);
      });
    },
  },
} as const;

const comparePrsId = (a: string, b: string): number => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
